import Vue from 'vue'
import BaseDetail from './main-detail.vue'
import BaseForm from './main-form.vue'
import BaseTable from './main-table.vue'
import MainFilter from './main-filter.vue'
import BaseCard from './main-card.vue'
import BaseCRUD from './main-crud.vue'
import compSingleUpload from './component/single-upload'
import compMultiUpload from './component/multiple-upload'
import compLookupInput from './component/lookup-input'
import compLookupAdd from './component/lookup-add'
import compMappingInput from './component/mapping-input'
import compSingleInput from './component/single-input'
import compTableInput from './component/table-input'
import gmaps from './component/gmap.vue'
import pagination from './component/_pagination.vue'
import compStatisticTable from './component/statistic-table'
import LocationComponent from './component/location-form-component.vue'
import InlineFilter from './component/inline-filter.vue'
import HeaderStatistic from './component/header-statistic.vue'
import ImageModal from './component/image-modal.vue'
import BaseAlert from './component/alert.vue'
import BaseDetailCard from './component/card-detail.vue'
import BaseTableStatistic from './component/table-statistic.vue'
import BaseTableDetail from './component/table-detail.vue'
import baseTabs from './component/base-tabs.vue'
import baseTab from './component/base-tab.vue'
import simpleTable from './component/simple-table.vue'
import singlePolygonLoader from './component/single-polygon-loader.vue'
import multiPolygonLoader from './component/multi-polygon-loader.vue'
import baseMapCoordinate from './component/base-map-coordinate.vue'
import baseSubmissionTable from './component/simple-submission-table.vue'



import notFound from '../default-page/404.vue'

Vue.component('tas-base-table', BaseTable)
Vue.component('tas-base-card', BaseCard)
Vue.component('tas-base-form', BaseForm)
Vue.component('tas-base-detail', BaseDetail)
Vue.component('tas-base-crud', BaseCRUD)
Vue.component('base-filter', MainFilter)
Vue.component('s-input', compSingleInput)
Vue.component('single-upload', compSingleUpload)
Vue.component('multi-upload', compMultiUpload)
Vue.component('lookup-input', compLookupInput)
Vue.component('lookup-add', compLookupAdd)
Vue.component('mapping-input', compMappingInput)
Vue.component('table-input', compTableInput)
Vue.component('not-found', notFound)
Vue.component('g-maps', gmaps)
Vue.component('pagination', pagination)
Vue.component('statistic-table', compStatisticTable)
Vue.component('location-form', LocationComponent)
Vue.component("inline-filter", InlineFilter);
Vue.component("header-statistic", HeaderStatistic)
Vue.component("image-modal", ImageModal);
Vue.component("base-alert", BaseAlert);
Vue.component("base-detail-card", BaseDetailCard);
Vue.component("base-table-statistic", BaseTableStatistic);
Vue.component("base-table-detail", BaseTableDetail);
Vue.component("base-tabs", baseTabs);
Vue.component("base-tab", baseTab);
Vue.component("base-simple-table", simpleTable);
Vue.component("base-single-polygon-loader", singlePolygonLoader);
Vue.component("base-multi-polygon-loader", multiPolygonLoader);
Vue.component("base-map-coordinate-loader", baseMapCoordinate);
Vue.component("base-submission-table", baseSubmissionTable);



// WEBPACK FOOTER //
// ./src/base/_base-component.js